var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuaiInvest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 22,
    viewBox: "0 0 144 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6264 21.8872H10.6653C4.76457 21.8872 0 16.9795 0 10.9436C0 7.91624 1.19114 5.18974 3.13362 3.19658C5.05778 1.22222 7.71494 0 10.6653 0C13.6157 0 16.2912 1.22222 18.197 3.19658C19.1682 4.19316 19.9379 5.37778 20.4877 6.69402C21.0374 7.99145 21.3306 9.43932 21.3306 10.9624C21.3306 13.3692 20.5793 15.588 19.2782 17.3932C19.0033 17.8068 18.6735 18.1829 18.3253 18.5402L15.2466 15.3436C16.3095 14.1966 16.9509 12.6547 16.9509 10.9436C16.9509 9.15727 16.2545 7.55897 15.1184 6.39316C13.9822 5.22735 12.3879 4.51282 10.6653 4.51282C8.94274 4.51282 7.36676 5.22735 6.23059 6.39316C5.09443 7.55897 4.39807 9.15727 4.39807 10.9436C4.39807 14.4974 7.20183 17.3744 10.6653 17.3744V12.7111L19.6264 21.8872Z",
    fill: "url(#paint0_linear_517_9448)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6085 6.44959C32.7289 6.44959 32.0142 7.18292 32.0142 8.08549V15.6633C32.0142 16.453 31.7393 17.1487 31.1896 17.7128C30.6398 18.2769 29.9618 18.559 29.1921 18.559C28.4408 18.559 27.7811 18.2957 27.2497 17.7692C26.6999 17.2428 26.425 16.5846 26.4067 15.8325V8.08549C26.4067 7.69062 26.2784 7.33335 26.0219 7.0325C25.9669 6.95728 25.8936 6.90087 25.8203 6.82566C25.5088 6.56241 25.1606 6.43079 24.7941 6.43079C23.9145 6.43079 23.1998 7.16412 23.1998 8.06668V15.8325C23.2181 17.4684 23.8228 18.8975 24.9956 20.0633C26.1685 21.2291 27.5795 21.812 29.1921 21.812C30.2917 21.812 31.2995 21.5299 32.2158 20.9846C32.3258 21.2103 32.4907 21.3983 32.7106 21.5487C32.9855 21.7368 33.3153 21.8308 33.6635 21.8308C34.5065 21.8308 35.1845 21.1163 35.1845 20.2701V8.08549C35.2028 7.18292 34.4881 6.44959 33.6085 6.44959Z",
    fill: "url(#paint1_linear_517_9448)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3917 8.02905C45.0435 7.12649 44.2006 6.54358 43.266 6.54358C42.3314 6.54358 41.4884 7.12649 41.1403 8.02905L36.5223 19.9316C36.3574 20.3829 36.394 20.8906 36.6689 21.3043C36.9438 21.7179 37.3836 21.9436 37.86 21.9436C38.1899 21.9436 38.5014 21.8496 38.758 21.6615C39.0328 21.4735 39.2344 21.229 39.3627 20.9094L40.1324 18.8786H46.4362L47.2059 20.9094C47.3342 21.229 47.5358 21.4735 47.7923 21.6615C48.0672 21.8496 48.3604 21.9436 48.6903 21.9436C49.1667 21.9436 49.6065 21.6991 49.8814 21.3043C50.1563 20.9094 50.1929 20.4017 50.028 19.9316L45.3917 8.02905ZM41.3968 15.6256L43.2477 10.812L45.1168 15.6256H41.3968Z",
    fill: "url(#paint2_linear_517_9448)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2715 6.54358C52.3919 6.54358 51.6772 7.27691 51.6772 8.17948V20.2889C51.6772 21.1914 52.3919 21.9248 53.2715 21.9248C54.1512 21.9248 54.8658 21.1914 54.8658 20.2889V8.17948C54.8658 7.72819 54.7009 7.33332 54.3894 7.01366C54.0962 6.69401 53.7114 6.54358 53.2715 6.54358Z",
    fill: "url(#paint3_linear_517_9448)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4474 6.52478C65.6228 6.52478 64.9631 7.2017 64.9631 8.04786V20.3265C64.9631 21.1726 65.6411 21.8496 66.4474 21.8496C67.2721 21.8496 67.9318 21.1726 67.9318 20.3265V8.04786C67.9318 7.61538 67.7668 7.23931 67.492 6.95726C67.2354 6.69401 66.8689 6.52478 66.4474 6.52478Z",
    fill: "url(#paint4_linear_517_9448)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4533 6.54356C82.6103 6.52475 81.9323 7.27689 81.9323 8.12305V17.0359L73.3744 6.99484C73.1361 6.71279 72.788 6.54356 72.4031 6.54356H71.5052C71.0837 6.54356 70.7172 6.71279 70.4057 7.05125V7.07005C70.2591 7.23928 70.1491 7.40852 70.0941 7.59655V7.61535C70.0208 7.74698 69.9842 7.91621 69.9842 8.08544V20.3453C69.9842 21.1726 70.6256 21.8871 71.4502 21.8871C71.89 21.8871 72.2382 21.7367 72.5497 21.4359C72.8429 21.135 72.9895 20.7777 72.9895 20.3641V11.4324L81.5291 21.4359C81.7673 21.7179 82.1155 21.8871 82.5004 21.8871H83.3983C83.8381 21.8871 84.2046 21.7367 84.4978 21.4171L84.5161 21.3983V21.3795C84.6444 21.229 84.7544 21.0598 84.8277 20.853C84.8826 20.7025 84.901 20.5333 84.901 20.3829V8.06664C84.9193 7.23928 84.2596 6.56236 83.4533 6.54356Z",
    fill: "url(#paint5_linear_517_9448)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8831 6.43079C98.5899 6.43079 98.315 6.5248 98.0585 6.69403C97.8019 6.88207 97.6187 7.10771 97.5087 7.40856L96.6841 9.51455L95.4929 12.5983L93.4222 17.9385L91.3331 12.5983L90.1603 9.51455L89.3357 7.40856C89.2624 7.22053 89.1707 7.0513 89.0241 6.90087C88.8775 6.75044 88.7126 6.63762 88.5293 6.56241C88.3461 6.4872 88.1628 6.43079 87.9429 6.43079C87.0083 6.43079 86.3486 7.40856 86.6968 8.31113L91.3881 20.3641C91.7179 21.2291 92.5242 21.7932 93.4405 21.7932C94.3384 21.7932 95.1448 21.2291 95.4929 20.3641L100.184 8.31113C100.459 7.40856 99.8177 6.43079 98.8831 6.43079Z",
    fill: "url(#paint6_linear_517_9448)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.627 18.8598H105.15V15.776H109.64C110.465 15.776 111.124 15.0991 111.124 14.253C111.124 13.4068 110.465 12.7299 109.64 12.7299H105.15V9.66493H112.609C113.433 9.66493 114.093 8.988 114.093 8.14185C114.093 7.2957 113.433 6.61877 112.609 6.61877H103.758C102.878 6.61877 102.163 7.35211 102.163 8.25467V20.3641C102.163 20.7777 102.31 21.135 102.603 21.4359C102.896 21.7367 103.245 21.8871 103.648 21.8871H112.627C113.433 21.8871 114.093 21.2102 114.093 20.3829C114.111 19.5367 113.452 18.8598 112.627 18.8598Z",
    fill: "url(#paint7_linear_517_9448)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.25 9.51454H126.188C126.463 9.51454 126.701 9.43933 126.939 9.3077C127.177 9.17608 127.361 8.98805 127.489 8.7436C127.617 8.49916 127.69 8.25471 127.69 7.97266C127.69 7.12651 127.031 6.44958 126.206 6.44958H120.25C119.023 6.44958 117.96 6.90087 117.08 7.78463C116.201 8.68719 115.779 9.75899 115.779 11.0376C115.779 12.2974 116.219 13.388 117.08 14.3094C117.941 15.212 119.004 15.6633 120.25 15.6633H123.237C123.531 15.6633 123.824 15.7385 124.062 15.9077C124.227 16.0205 124.374 16.171 124.484 16.3402C124.63 16.6034 124.722 16.8667 124.722 17.1863C124.722 17.6 124.575 17.9573 124.282 18.2769C123.989 18.5778 123.641 18.7282 123.237 18.7282H117.282C116.879 18.7282 116.53 18.8786 116.237 19.1795C115.944 19.4804 115.797 19.8376 115.797 20.2513C115.797 21.0974 116.475 21.7932 117.3 21.7932H123.219C124.465 21.7932 125.528 21.3419 126.408 20.4393C127.287 19.5368 127.709 18.4462 127.709 17.1675C127.709 15.9077 127.269 14.8171 126.408 13.9145C125.528 13.012 124.484 12.5795 123.219 12.5795H120.25C119.829 12.5795 119.481 12.4291 119.188 12.1282C118.894 11.8274 118.748 11.4701 118.748 11.0564C118.748 10.6427 118.894 10.2479 119.188 9.96582C119.481 9.66497 119.829 9.51454 120.25 9.51454Z",
    fill: "url(#paint8_linear_517_9448)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.497 6.43079H130.586C129.761 6.43079 129.083 7.12651 129.083 7.97267C129.083 8.38634 129.23 8.74361 129.523 9.04446C129.816 9.34532 130.164 9.49574 130.586 9.49574H135.039V20.2513C135.039 21.0975 135.699 21.7744 136.523 21.7744C136.798 21.7744 137.036 21.6992 137.275 21.5675C137.513 21.4359 137.696 21.2479 137.824 21.0222C137.953 20.7966 138.026 20.5334 138.026 20.2701V9.53335H142.497C142.919 9.53335 143.267 9.38292 143.56 9.08207C143.853 8.78121 144 8.42395 144 8.01027C144 7.12651 143.322 6.43079 142.497 6.43079Z",
    fill: "url(#paint9_linear_517_9448)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_517_9448",
    x1: 5.28466,
    y1: 22.0743,
    x2: 20.6132,
    y2: -1.26754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0394E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_517_9448",
    x1: 29.1923,
    y1: 6.76925,
    x2: 29.1923,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_517_9448",
    x1: 43.2751,
    y1: 6.76922,
    x2: 43.2751,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_517_9448",
    x1: 53.2715,
    y1: 6.76922,
    x2: 53.2715,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_517_9448",
    x1: 66.4523,
    y1: 6.76922,
    x2: 66.4523,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_517_9448",
    x1: 77.4375,
    y1: 6.7692,
    x2: 77.4375,
    y2: 21.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_517_9448",
    x1: 93.4116,
    y1: 6.76925,
    x2: 93.4116,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_517_9448",
    x1: 108.14,
    y1: 6.7692,
    x2: 108.14,
    y2: 21.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_517_9448",
    x1: 121.736,
    y1: 6.76924,
    x2: 121.736,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_517_9448",
    x1: 136.536,
    y1: 6.76925,
    x2: 136.536,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A3781"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuaiInvest);
export default __webpack_public_path__ + "static/media/quai_invest.b3a4265dd6a244cfd9f03cbd7fde2cdc.svg";
export { ForwardRef as ReactComponent };